import { render, staticRenderFns } from "./SectionPanel.vue?vue&type=template&id=4a09a05e&scoped=true&"
import script from "./SectionPanel.vue?vue&type=script&lang=js&"
export * from "./SectionPanel.vue?vue&type=script&lang=js&"
import style0 from "./SectionPanel.vue?vue&type=style&index=0&id=4a09a05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a09a05e",
  null
  
)

export default component.exports